import * as React from "react";

const SMALL_VIEWPORT_HEIGHT = 800;

export function useIsSmallViewportHeight(
  breakpoint: number = SMALL_VIEWPORT_HEIGHT,
): boolean {
  const [isSmall, setIsSmall] = React.useState<boolean>(() =>
    typeof window !== "undefined" ? window.innerHeight <= breakpoint : false,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-height: ${breakpoint}px)`);
    const onChange = () => setIsSmall(window.innerHeight <= breakpoint);
    mql.addEventListener("change", onChange);
    setIsSmall(window.innerHeight <= breakpoint);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return isSmall;
}
